import { defineComponent, computed } from 'vue';

export default defineComponent({
  name: 'message',
  template: '#message-template',
  props: {
    message: {
      type: Object,
      required: true,
    },
    active_dialog_id: {
      type: [String, Number],
      required: false,
      default: null,
    },
  },
  setup(props, { emit }) {
    // outgoing isn't always serialized; fall back to sender_type.
    const from = computed(() => (props.message.outgoing || props.message.sender_type === 'Account') ? 'me' : 'you');

    const deleteClicked = () => {
      emit('remove', props.message);
    };

    return {
      from,
      deleteClicked,
    };
  },
});
